export default "./images/ED110.jpg";